import { AnyAction } from "redux"
import { cloneDeep } from 'lodash';
import { ASSIGN_ROLES_TO_USER, FETCH_ALL_ROLES, FETCH_ALL_USERS_WITH_ROLES, FILTER_BY_COMPANY_ROLE, FILTER_BY_NAME_CPF, RESET } from "../actions/userRole";
import Role from "../../models/core/userRole/Role";
import PersonCompany from "../../models/core/userRole/PersonCompany";

interface IUser{
    allRoles: Role[];
    rolesCombo: any[]; 
    usersWithRoles: PersonCompany[];
}

const initialState: IUser = {
    allRoles: [],
    rolesCombo: [],
    usersWithRoles: []
}

export const UserRoleReducer = (state = initialState, action: AnyAction) =>{
    switch(action.type){
        case RESET:{
            return {
                ...cloneDeep(initialState)
            }
        }
        case FETCH_ALL_ROLES:{
            return{
                ...cloneDeep(state),
                allRoles: action.roles,
                rolesCombo: action.rolesCombo
            }
        }
        case FETCH_ALL_USERS_WITH_ROLES:{
            return{
                ...cloneDeep(state),
                usersWithRoles: action.users
            }
        }
        case ASSIGN_ROLES_TO_USER:{
            return{
                ...cloneDeep(state),
            }
        }
        case FILTER_BY_COMPANY_ROLE:{
            return{
                ...cloneDeep(state),
                usersWithRoles: action.filteredUsers
            }
        }
        case FILTER_BY_NAME_CPF:{
            return{
                ...cloneDeep(state),
                usersWithRoles: action.filteredUsers
            }
        }
        default:{
            return state 
        }
    }
}